var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createFormFromSelector } from "../utils.js";
export var EWA;
(function (EWA) {
    function getEmployeeProfile(ctx, companyId, employeeId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "employees", employeeId));
            const data = yield res.json();
            return data;
        });
    }
    EWA.getEmployeeProfile = getEmployeeProfile;
    function confirmRequest(ctx, companyId, requestId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "requests", requestId, "confirm"), {
                method: "POST",
            });
            return;
        });
    }
    EWA.confirmRequest = confirmRequest;
    function approveRequest(ctx, companyId, requestId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "requests", requestId, "approve"), {
                method: "POST",
            });
            return;
        });
    }
    EWA.approveRequest = approveRequest;
    function rejectRequest(ctx, companyId, requestId, reason) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = reason ? JSON.stringify({ reason }) : undefined;
            yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "requests", requestId, "reject"), {
                method: "POST",
                body,
                headers: {
                    "Content-Type": "application/json",
                },
            });
            return;
        });
    }
    EWA.rejectRequest = rejectRequest;
    function queryRepayments(ctx_1, companyId_1) {
        return __awaiter(this, arguments, void 0, function* (ctx, companyId, params = {}) {
            const form = createFormFromSelector(params);
            const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "query/repayments"), {
                method: "POST",
                body: form.toString(),
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            return (yield res.json());
        });
    }
    EWA.queryRepayments = queryRepayments;
    function getTerms(ctx, companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "terms"));
            return (yield res.json());
        });
    }
    EWA.getTerms = getTerms;
    function getTermRepayments(ctx, companyId, term) {
        return __awaiter(this, void 0, void 0, function* () {
            if (term !== "active" && term["id"] === undefined) {
                throw new Error("argument as invalid shape. must either be \"active\" or have an input of shape { 'id': <termid> }");
            }
            const termId = term === "active" ? term : term.id;
            const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "terms", termId, "records"));
            return (yield res.json());
        });
    }
    EWA.getTermRepayments = getTermRepayments;
    function getOrganization(ctx, companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId), {
                method: "GET",
            });
            return (yield res.json());
        });
    }
    EWA.getOrganization = getOrganization;
    function getPendingAdvancesOverview(ctx, companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "statistics/repayments/pending/aggregate"));
            return (yield res.json());
        });
    }
    EWA.getPendingAdvancesOverview = getPendingAdvancesOverview;
    function getAdvance(ctx, companyId, advanceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "advances", advanceId));
            return (yield res.json());
        });
    }
    EWA.getAdvance = getAdvance;
    function getAdvanceSchedule(ctx, companyId, advanceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "advances", advanceId, "schedule"));
            return (yield res.json());
        });
    }
    EWA.getAdvanceSchedule = getAdvanceSchedule;
    function getAdvancePenalties(ctx, companyId, advanceId, referenceDate) {
        return __awaiter(this, void 0, void 0, function* () {
            const q = new URLSearchParams();
            if (referenceDate) {
                q.set("reference", referenceDate.toISOString());
            }
            const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "advances", advanceId, "penalties"));
            return (yield res.json());
        });
    }
    EWA.getAdvancePenalties = getAdvancePenalties;
    function createAdvanceOrder(ctx, companyId, employeeId, data, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const advdata = {
                data,
                shouldNotify: (_a = opts.notify) !== null && _a !== void 0 ? _a : true,
            };
            const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "employees", employeeId, "make-advance-request"), {
                method: "POST",
                body: JSON.stringify(advdata),
                headers: {
                    "Idempotent-Key": opts.idempotentKey,
                    "Content-Type": "application/json",
                },
            });
            return (yield res.json());
        });
    }
    EWA.createAdvanceOrder = createAdvanceOrder;
    function previewAdvanceOrder(ctx, companyId, employeeId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = data.type === "simple"
                ? {
                    type: data.type,
                    requestedAmount: data.requestedAmount,
                }
                : {
                    type: data.type,
                    requestedAmount: data.requestedAmount,
                    repaymentPlan: data.repaymentPlan,
                };
            const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "employees", employeeId, "preview-advance-request"), {
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                    "Content-Type": "application/json",
                },
            });
            return (yield res.json());
        });
    }
    EWA.previewAdvanceOrder = previewAdvanceOrder;
    function getOrganizationStatisticsOverview(ctx, companyId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const q = createFormFromSelector(params);
            const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "statistics/overview"), {
                method: "POST",
                body: q.toString(),
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            return (yield res.json());
        });
    }
    EWA.getOrganizationStatisticsOverview = getOrganizationStatisticsOverview;
    function getRepayments(ctx, companyId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const q = createFormFromSelector(params);
            const res = yield ctx.client.fetch(`${ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "repayments")}?${q.toString()}`);
            return (yield res.json());
        });
    }
    EWA.getRepayments = getRepayments;
    function queryAdvances(ctx, companyId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const formdata = createFormFromSelector(params);
            const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "query/advances"), {
                method: "POST",
                body: formdata,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            return (yield res.json());
        });
    }
    EWA.queryAdvances = queryAdvances;
    function queryRequests(ctx, companyId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const formdata = createFormFromSelector(params);
            const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "query/requests"), {
                method: "POST",
                body: formdata,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            return (yield res.json());
        });
    }
    EWA.queryRequests = queryRequests;
    function queryEmployees(ctx, companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "employees"));
            return (yield res.json());
        });
    }
    EWA.queryEmployees = queryEmployees;
    function getOrganizationStatisticsVariables(ctx, companyId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const formdata = createFormFromSelector(params);
            const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "statistics/overview/variables"), {
                method: "POST",
                body: formdata,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            return (yield res.json());
        });
    }
    EWA.getOrganizationStatisticsVariables = getOrganizationStatisticsVariables;
})(EWA || (EWA = {}));
